<router-outlet *ngIf="loaded; else loading" name="pdp"></router-outlet>
<ng-template #loading>
  <ox-cms-loading></ox-cms-loading>
</ng-template>
